import React from "react";
import { Form, Checkbox } from "antd";

export const CheckboxGroupItem = ({
  name,
  label,
  required = false,
  rules = [],
  optionItems,
  direction = "horizontal"
}) => {
  const directionStyle = direction === "vertical" ? { display: "flex", flexDirection: "column" } : {};

  return (
    <Form.Item rules={[{ required }, ...rules]} name={name} label={label}>
      <Checkbox.Group options={optionItems} style={{ ...directionStyle }} />
    </Form.Item>
  );
};
